<template>
  <PModalBox
    :open-dialog="openDialog"
    :header="editMode ? 'Edit Supplier' : 'Add Supplier'"
    id="supplier-dialog"
    size="large"
    @close-dialog="close"
  >
    <template #content>
      <InputSingleSupplier
        :can-upload-business-partner="canUploadBusinessPartner"
        :edit-mode="editMode"
        :supplier="supplier"
        @change="$emit('change')"
      />
    </template>
  </PModalBox>
</template>

<script setup lang="ts">
import { Supplier } from "@/models/supplier";
import { ref, onBeforeUpdate } from "vue";
import InputSingleSupplier from "@/views/supplier-registry/InputSingleSupplier.vue";
import PModalBox from "@/components/custom/PModalBox.vue";

const emit = defineEmits<{
  (e: "closeDialog"): void;
  (e: "change"): void;
}>();

const props = withDefaults(
  defineProps<{
    openDialog: boolean;
    canUploadBusinessPartner: boolean;
    editMode?: boolean;
    supplier?: Supplier;
  }>(),
  {
    editMode: false,
  }
);

const editableSupplier = ref(new Supplier());

onBeforeUpdate(() => {
  if (props.supplier == null) {
    editableSupplier.value = new Supplier();
  } else {
    editableSupplier.value = { ...props.supplier };
  }
});

const close = () => {
  emit("closeDialog");
};
</script>
